// eslint-disable-next-line import/no-cycle
import http from '../tools/http';

export default {
  create(organizationUUID, fields) {
    return http.post(`/organizations/${organizationUUID}/exports`, fields);
  },
  getAll(organizationUUID, resource) {
    return http.get(`/organizations/${organizationUUID}/exports/resources/${resource}`);
  },
  getOne(organizationUUID, downloadUUID) {
    return http.get(`organizations/${organizationUUID}/exports/${downloadUUID}`);
  },
  delete(organizationUUID, downloadUUID) {
    return http.delete(`/organizations/${organizationUUID}/exports/${downloadUUID}`);
  },
  createGeneral(fields) {
    return http.post('/organizations/exports', fields);
  },
  getAllGeneral(resource) {
    return http.get(`/organizations/exports/resources/${resource}`);
  },
  getOneGeneral(downloadUUID) {
    return http.get(`/organizations/exports/${downloadUUID}`);
  },
  deleteGeneral(downloadUUID) {
    return http.delete(`/organizations/exports/${downloadUUID}`);
  },
  getAllWithProgress(organizationUUID, resource) {
    return http.get(`/organizations/${organizationUUID}/exports/sse/resources/${resource}`);
  },
  cancel(organizationUUID, exportUUID) {
    return http.patch(`/organizations/${organizationUUID}/exports/${exportUUID}/cancel`);
  },
};
